import Hero from "../../components/Hero/Hero";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import SEO from "../../components/SEO/SEO";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useEffect, useState } from "react";
import { hexToRgb } from "../../utils/utils";
import { UPLOAD } from "../../utils/const";
import { getArithmeticalEvaluation, getEvaluationRight, } from "../../redux/slices/evaluator/evaluatorThunk";
import EvaluationCard from "./components/EvaluationCard";
import { clearEvaluation, clearTypeOfIndicator } from "../../redux/slices/evaluator/evaluatorSlice";
import EvaluationTypeOfIndicator from "./components/EvaluationTypeOfIndicator";
import { getExtendedRight } from "../../redux/slices/indicatorDisplay/SearchAndFilter/filterAndSearchThunk";
import { sendAnalyticsEvent } from "../../FirebaseConfig";
import useIsMobile from "../../hooks/useIsMobile";
import { setSelectedPeriod } from "../../redux/slices/periods/periodsSlice";
import EvaluationInProgress from "./components/EvaluationInProgress";
import ContactSection from "../../components/Common/ContactSection";
import Loading from "../../components/Loading/Loading";
const { REACT_APP_BACKOFFICE_CONNECTION } = process.env;

const Index = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const [right, setRight] = useState("");
  const [rightId, setRightId] = useState("");

  const [period, setPeriod] = useState<string>("");
  const [selectedPeriodEvaluador, setSelectedPeriodEvaluador] = useState<string>("");

  const isMobile = useIsMobile();

  const {
    loading_arithmetical,
    evaluation_right,
    arithmetical_evaluation_right,
    trivalent_evaluation_right,
    evaluation_indicator_type,
  } = useAppSelector((state) => state.evaluator);

  const { periods, lastPeriod } = useAppSelector((state) => state.periods);

  useEffect(() => {
    const rightId = params.get("rightId") || "";
    const right = params.get("right") || "";
    const period = params.get("periodo") || "";

    setRight(right);
    setRightId(rightId);

    if (!evaluation_right && !arithmetical_evaluation_right) {
      dispatch(getEvaluationRight({ right: rightId, period: period }));
      dispatch(getArithmeticalEvaluation({ right: rightId, period: period }));
      dispatch(getExtendedRight({ right: params.get("right") || "", period }));

      setPeriod(period);
      setSelectedPeriodEvaluador(`Período ${period}`);
    }

    if (right) {
      sendAnalyticsEvent("evaluated_right", {
        right_name: right.trim().toLowerCase(),
      });
    }
  }, [location.search, dispatch]);

  useEffect(() => {
    const period = params.get("periodo") || "";
    if (period && periods && periods.length > 0) {
      dispatch(setSelectedPeriod({ period }));
    }
  }, [location.search, periods]);

  useEffect(() => {
    return () => {
      dispatch(clearEvaluation());
    };
  }, []);

  const onSelectPeriod = (value: string) => {
    if (value.length) {
      const year = value.split(" ")[1];
      setSelectedPeriodEvaluador(`Período ${year}`);

      const params = new URLSearchParams(location.search);
      const right = params.get("rightId") || "";

      dispatch(clearTypeOfIndicator());

      dispatch(getEvaluationRight({ right, period: year }));
      dispatch(getArithmeticalEvaluation({ right, period: year }));
      dispatch(setSelectedPeriod({ period: value }));
      params.delete("periodo");
      params.set("periodo", year);
      navigate({ search: params.toString() });
    }
  };

  if (!evaluation_right) return (
    <div className='flex-1 w-full flex items-center justify-center'>
      <Loading size={40} />
    </div>
  );

  return (
    <>
      <SEO
        title={`Evaluador de ${evaluation_right?.titulo}`}
        description="Evaluador de derechos"
        type="article"
      />
      <Hero
        breadcrumbs={<Breadcrumbs />}
        title={`Evaluador de ${evaluation_right?.titulo}`}
        paragraph={evaluation_right?.descripcion}
        layout="row"
        backgroundClassName={{ backgroundColor: `rgb(${hexToRgb(evaluation_right?.color)}, 0.25)` }}
        imageContainerClassName={{ backgroundColor: `${evaluation_right?.color}` }}
        media={{
          type: "image",
          src: `${REACT_APP_BACKOFFICE_CONNECTION}${UPLOAD}${evaluation_right?.imagen}`,
          url: "",
          alt: "visualizador",
          className:
            "hidden lg:inline lg:w-[304px] lg:h-[172px] xl:w-[360px] xl:h-[204px] object-contain xl:object-cover",
        }}
        expandableDescription={isMobile ? true : false}
        descriptionClassName='w-[96%]'
        buttonExpandableDescriptionClassName="md:hidden"
        containerHeightClassName="h-[37rem] sm:h-[30rem]"
        titleClassName='text-brand-green-20'
      />
      <EvaluationCard
        trivalent_evaluation_right={trivalent_evaluation_right ?? null}
        arithmeticalEvaluation={arithmetical_evaluation_right ?? []}
        periodOptions={periods ?? []}
        defaultSelectedItemSelect={`Período ${period}`}
        onSelectPeriod={onSelectPeriod}
        selectedPeriod={selectedPeriodEvaluador}
        loading={loading_arithmetical}
      />
      {lastPeriod && lastPeriod.estado === 2 && loading_arithmetical !== "pending" && <EvaluationInProgress />}
      <EvaluationTypeOfIndicator
        evaluation_indicator_type={evaluation_indicator_type ?? []}
        right={right}
        rightId={rightId}
      />
      <ContactSection />
    </>
  );
};

export default Index;